import script from "./SideBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=5930e018&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5930e018"]])

export default __exports__